export const LongTermOptionsGetters = {
  analysisOptions: state => state.analysisOptions,
  longTermOptions: state => state.longTermOptions,
}
